'use client';

import React from 'react';

const NavContainer = (props: {
  requiresTransparentBackground: boolean;
  children: React.ReactNode;
}) => {
  const { children } = props;

  return <div className="nav-container-wrapper">{children}</div>;
};

export default NavContainer;
